// Global JS
// --

// Phone Number Text Animation
// var phoneNumberSpan = $("#phoneNumber");
// var phoneNumber = phoneNumberSpan.data("number");
// var phoneNumberList = phoneNumber.toString().split("");

// $.each(phoneNumberList, function(idx, elem) {
//   //create a span for the letter and set opacity to 0
//   var newEL = $("<span/>")
//     .text(elem)
//     .css({ opacity: 0 });

//   // append number to phone element
//   newEL.appendTo(phoneNumberSpan);

//   //set the delay on the animation for this element
//   newEL.delay(idx * 70);

//   //animate the opacity back to full 1
//   newEL.animate(
//     {
//       opacity: 1
//     },
//     5000
//   );
// });

// Navigation "active" toggle
var currentPathName = location.pathname;
$(".navbar-custom li a").each(function() {
  var $this = $(this);
  // if the current path is like this link, make it active
  if ($this.attr("href") == currentPathName) {
    $this.parent().addClass("active");
  }
});

// Tooltips - Initialize all
$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

// Disable autocomplete, paste, and drag-and-drop for all input and textarea fields
document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('input, textarea');

  inputs.forEach(input => {
    input.setAttribute('autocomplete', 'off');

    input.addEventListener('paste', function (e) {
      e.preventDefault();
    });

    input.addEventListener('drop', function (e) {
      e.preventDefault();
    });
  });
});

// Show / Hide Social Security Number
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ssn-toggle, .ssn-group-toggle').forEach(function (button) {
    button.addEventListener('click', function () {
      const container = button.closest('.ssn-field, .ssn-group');

      if (!container) return;

      const inputs = container.classList.contains('ssn-group')
        ? container.querySelectorAll('.ssn-wpr input')
        : container.querySelectorAll('[data-ssn-input]');

      if (!inputs.length) return;

      const showSSN = inputs[0].type === 'password';

      inputs.forEach(function (input) {
        input.type = showSSN ? 'text' : 'password';
      });

      button.setAttribute('aria-label', showSSN ? 'Hide SSN' : 'Show SSN');
      button.setAttribute('aria-pressed', String(showSSN));

      // Update eye icon
      button.classList.toggle('ssn-visible', showSSN);
    });
  });
});
